import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
} from "@mui/material";
// page d'accueil sans les questions
export default function IntroductionStartCard({ pageCount, setPageCount, handleStart, projectName, setProjectName }) {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="90vh">
      <Card
        sx={{
          maxWidth: 500,
          p: 3,
          borderRadius: 3,
          boxShadow: 3,
          border: "1px solid #e0e0e0",
        }}
      >
        <CardContent>
          <Typography variant="h4" gutterBottom textAlign="center" color="primary">
            Experiment Form
          </Typography>
          <Typography
            variant="subtitle1"
            mb={2}
            textAlign="center"
            sx={{ fontSize: "1.2rem", color: "text.secondary" }}
          >
            Introduction
          </Typography>

          <Typography variant="body1" mb={2} sx={{ fontSize: "1.1rem" }}>
            In this form, the following definitions are given:
          </Typography>

          <Typography variant="body1" mb={1} sx={{ fontSize: "1.1rem", color: "text.secondary" }}>
            • <strong>Experiment:</strong> A series of interventions on one or several cohorts of animals.
          </Typography>
          <Typography variant="body1" mb={1} sx={{ fontSize: "1.1rem", color: "text.secondary" }}>
            • <strong>Intervention:</strong> An action performed on an animal.
          </Typography>
          <Typography variant="body1" mb={1} sx={{ fontSize: "1.1rem", color: "text.secondary" }}>
            • <strong>Procedure:</strong> A detailed description of the intervention.
          </Typography>
          <Typography variant="body1" mb={2} sx={{ fontSize: "1.1rem", color: "text.secondary" }}>
            • <strong>Acclimatation:</strong> Mandatory resting time before the first intervention.
          </Typography>

          <TextField
            label="Enter number of experiment types"
            variant="outlined"
            fullWidth
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "primary.main",
                },
                "&:hover fieldset": {
                  borderColor: "primary.dark",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "primary.main",
                },
              },
            }}
            value={pageCount}
            onChange={(e) => setPageCount(e.target.value)}
          />
           <TextField
            label="Enter project's name"
            variant="outlined"
            fullWidth
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "primary.main",
                },
                "&:hover fieldset": {
                  borderColor: "primary.dark",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "primary.main",
                },
              },
            }}
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            onClick={handleStart}
            disabled={!pageCount}
            sx={{ textTransform: "none" }}
          >
            Start
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
